module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter2"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block8"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TOC"
    }
  }, [_vm._v("Chapter 2")])]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "h19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Text/TOC"
    }
  }, [_vm._v("Brie")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p134"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("I")]), _vm._v(" hate today,” I declare dramatically and Len laughs in my face.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p135"
    }
  }, [_vm._v("“Thanks, pal,” she replies tartly. “Since you spent the last three hours in here with me, I appreciate that.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p136"
    }
  }, [_vm._v("I smile sheepishly at my best friend, who also happens to be my accountant. “You know I love you. It’s just I hate math. I hate paperwork. I hate numbers.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p137"
    }
  }, [_vm._v("“Yeah, yeah.” Len nods, her eyes back on the laptop screen in front of her. One hand zips around the track pad and the other twirls one of her dark curls around her finger. “I swear we’re only friends because together we are a whole, fully functional person. Separately we’re disasters.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p138"
    }
  }, [_vm._v("I nod. We’ve been saying that since we met at age twelve in school. I’m intuitive and street smart, she’s analytical and book smart. She tutored me in high school when I was struggling with calculus and I, more than once, have saved her from sketchy potential suitors and internet scams.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p139"
    }
  }, [_vm._v("“We’re almost done here and then you can get back to your precious children,” Len says and smiles to offset her judgy tone. She loves these kids as much as I do, she’s just too scared to admit it. If she didn’t she wouldn’t volunteer here at Daphne’s House, which is the charity for homeless teens that I founded. She offered to teach a budgeting class as soon as the doors opened; I didn’t even have to ask or beg and I would have done both.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p140"
    }
  }, [_vm._v("“Yeah but before I leave here you’re going to give me that horrible number and it will put me in a bad mood,” I sigh, dramatically again. The number I’m referring to is the amount of donations we need for the last quarter of the year.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p141"
    }
  }, [_vm._v("We’re doing a fund-raiser in a few weeks and if the number we have to hit is astronomical I’m going to get depressed. I would dip into my own savings again, but at this point if I do, I won’t be able to pay my own bills. This year we just haven’t gotten the media exposure we have in the past and if people don’t know about us, they can’t donate. I’ve tapped out all my personal contacts. My parents have been more than generous with donations and would help me out if I ask, but my dad just retired and I am not eating away at his hard-earned savings. He and Mom have made plans for that money and they deserve to keep them.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p142"
    }
  }, [_vm._v("“I wouldn’t worry about it,” Len says and gives me a comforting smile. “Just have Vic invite all his snooty friends to the fund-raiser. They love to throw money at things they think makes them look like a good person. It’s easier than actually being one.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p143"
    }
  }, [_vm._v("I let that go like I always do because Len has every right to be bitchy and I am still feeling guilty for setting her up with Robert, one of Victor’s close friends, who dated her for almost two months and then completely ghosted her. Instead I correct her on the one thing I can without feeling bad. “Victor. You know he hates being called Vic.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p144"
    }
  }, [_vm._v("Her wide, perfectly glossed mouth takes a downward turn. “See? Snooty.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p145"
    }
  }, [_vm._v("I can’t help but laugh. I’ve known since almost day one that Len didn’t like Victor. But she tolerates him and respects my decision to date him. Still, I get the distinct impression she didn’t think it would last six days let alone six months.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p146"
    }
  }, [_vm._v("I glance at the clock. “How much longer, tax master? I have a new volunteers coming in here and need to prep the classroom for the GED lesson.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p147"
    }
  }, [_vm._v("“Fifty grand…give or take ten grand,” Len says firmly. Her blue eyes finally look up and meet mine and when she sees my pale face she adds. “Not too bad. I think you’ll be able to make that at the Hamptons thing.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p148"
    }
  }, [_vm._v("“So sixty thousand dollars?” I croak, feeling sick.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p149"
    }
  }, [_vm._v("“Fifty…give or take ten grand,” she repeats, pauses, and relents. “Yeah. Sixty. It just feels less painful the other way.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p150"
    }
  }, [_vm._v("“Fuck. Fuck. Fuckity, fuck, fuck.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p151"
    }
  }, [_vm._v("“Brie, seriously, we can do this.” Len covers my hand with hers on the desk. “I’m bringing everyone I know. And I will make sure they donate. We can do this.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p152"
    }
  }, [_vm._v("“I hope so,” I say and force myself not to dwell on it. I’ll panic after the fund-raiser, if I have to, not now. I can’t even think about losing this place. I won’t. I stand up. “Time to tackle the classroom. The art teacher who came in last night to teach sketching didn’t clean up afterward.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p153"
    }
  }, [_vm._v("Len looks up. “How’s Hesperia? Have you heard from her?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p154"
    }
  }, [_vm._v("I smile. She loves to pretend she’s an ice queen but Eleanor Levitt is a big old ball of mush. Hesperia is one of our recent success stories. She came to Daphne’s House two years ago when she was sixteen after she’d run away from her fifteenth foster home. She was easily angered and had major trust issues, but we convinced the judge to let her into our unsupervised housing facility and skills program and he did. Hesperia stuck with the program here, taking all our life skill classes and seminars and even earned her GED. She never once broke the rules. She left seven months ago after snagging a job and finding a room to rent in the Bronx. “Yes. She’s passed her probation period at work and got a bit of a pay bump. She’s loving the job and her roommates. She said she’s even started a little savings account and is thinking of taking college courses online.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p155"
    }
  }, [_vm._v("“Yes!” Len raises her hand for a high five and I give her one.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p156"
    }
  }, [_vm._v("“I invited her to the fund-raiser so you can get her to praise your amazing accounting courses when you see her there,” I say with a chuckle.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p157"
    }
  }, [_vm._v("Len feigns offense. “I don’t do it for the praise. That’s just something I have to endure, because I am an inspiring and incredible human. Not my fault.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p158"
    }
  }, [_vm._v("“Eleanor Levitt, don’t ever change,” I giggle.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p159"
    }
  }, [_vm._v("“You either, Gabrielle Bennett.” She winks at me. “I’m going to stick around and get some other work done. Can I squat here?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p160"
    }
  }, [_vm._v("“Of course,” I say, heading for the door. “Feel free to come help me clean if you’re bored.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p161"
    }
  }, [_vm._v("“I’ll never be that bored, sweetheart.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p162"
    }
  }, [_vm._v("I’m smiling as I close the door and head down the hall to the classroom. I feel pride as I walk down the long, narrow first-floor hallway. Daphne’s House has been my dream since I was little. It’s a last chance for kids who haven’t had any luck. It’s not a shelter or a group home. It’s a semi-independent living facility, set up like a boardinghouse. The teens have their own bedrooms with locking doors, but they share bathrooms, a kitchen and living space. Everyone lives rent-free but must go to school or be working on their GEDs and take at least three of our offered life skill classes—be it cooking, fitness and nutrition or the budgeting and accounting classes. We also offer GED classes and art therapy, as well as yoga and meditation. We give them a safe place to start living on their own and the skills to do it successfully.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p163"
    }
  }, [_vm._v("I turn into the large classroom and get started cleaning up. As I start putting away easels, I hear Selena, one of our full-time employees, talking in the hall. She’s doing the orientation for the prospective volunteers. I was hoping to do it with her but I’m more behind than I realized.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p164"
    }
  }, [_vm._v("“And what’s the age range for the kids?” a female voice asks Selena.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p165"
    }
  }, [_vm._v("“All of the kids are between the ages of sixteen and seventeen and they’ve all been approved by the courts for this type of living. They move out when they turn eighteen. Of course we help find them living situations afterward and have even cosigned leases for them.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p166"
    }
  }, [_vm._v("“That’s amazing,” I hear someone else say. I turn off the water I’m currently washing some brushes in and gently place them in the sink. “I’m impressed.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p167"
    }
  }, [_vm._v("“I was impressed too when I researched this place. I’m even more impressed now that I work here,” Selena tells him as I turn from the sink to look at the entryway. I can’t see them. I want to go out there, but I don’t want to interrupt either. Selena is doing a great job on her own. “They do really great work. The owner is incredibly dedicated to the cause.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p168"
    }
  }, [_vm._v("“So is there an age restriction?” another voice asks.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p169"
    }
  }, [_vm._v("“We’ve never had someone come here under sixteen,” Selena tells him. “It’s much harder to get the courts to allow someone much younger to live in such an unrestricted environment. For some reason they still think that sticking them in a foster home with an adult that they don’t know or trust is better than no adult at all.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p170"
    }
  }, [_vm._v("Selena goes back into explaining what we do here. As I’m about to step in the hall to greet everyone, I hear the front door buzz behind me. I glance over my shoulder as a person seems to explode into the room. He’s a blur of broad shoulders and dark fabric and towers over me more than any kid here. He must have been expecting to run or something after he entered because his forward motion is so aggressive that he bumps into me before he can stop himself. I stumble about as gracefully as a drunk chicken. I grab the wall to stop myself from slamming into it. I turn to fully take in whoever the hell just did that.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p171"
    }
  }, [_vm._v("Our eyes lock and it’s like we’re colliding again.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p172"
    }
  }, [_vm._v("“"), _c('i', [_vm._v("Colisse!")]), _vm._v("” He exhales the French swear word under his breath.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p173"
    }
  }, [_vm._v("“What are you doing here?” I demand. Did this jackass hockey player follow me? Oh my God that would be insane. Is he insane?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p174"
    }
  }, [_vm._v("“I’m here for the volunteer info session,” he replies.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p175"
    }
  }, [_vm._v("“You’re Alex?” Selena interrupts looking at the clipboard in her hand. “I thought you weren’t going to make it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p176"
    }
  }, [_vm._v("“I’m sorry I’m late. I’m new to the city and I underestimated my commute,” he explains to her and then he somehow manages to give her a fairly dazzling smile, which she returns with her typical friendly one. “Well if you want to join the rest of the tour, I can explain what you missed afterward.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p177"
    }
  }, [_vm._v("“I’ll explain it to him afterward,” I tell Selena and then glance at the rest of the group. “My name is Brie Bennett and I’m the director of Daphne’s House.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p178"
    }
  }, [_vm._v("I smile brightly at all of them and make sure to let it dim a little as my eyes connect with Alex Larue again. But he smiles back, bright but lopsided. “Of course you are,” he mumbles and his dark blue eyes lift to the ceiling. I know he’s cursing God or the universe, or both. I’d do the same if I didn’t think it was unprofessional.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p179"
    }
  }, [_vm._v("Instead I turn back to the group. “Come this way into our classroom and Selena will explain more about the classes we offer the kids, all of which are taught by professionals who are donating their time and sometimes supplies, like charcoals and paper for our art class.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p180"
    }
  }, [_vm._v("The group filters by me into the large room. Selena smiles at me as she passes and makes her way to the front as she continues talking. Alex hangs back, closer to me than I would like. I get a whiff of his cologne, which is dark and warm and earthy. Not unpleasant even though it kind of makes me think of a lumberjack.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p181"
    }
  }, [_vm._v("Those dark blue eyes keep stealing furtive glances in my direction, which makes all the glaring I’m doing worth it. It would be wasted energy if he didn’t see it. I can’t help but really take in his face, since I’m trying to melt it with my angry gaze. He’s got really dark, really thick five-o’clock shadow but it’s nicked in places by white scars like the two on his chin. There’s also one by his eye and through his eyebrow. He’s like an alley cat, all marked up and probably proud of it. Surprisingly for a hockey player, his nose is straight and smooth. His mouth is wide and his lips not overly full or thin but perfectly symmetrical. He’d be attractive if he wasn’t a sleazeball.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p182"
    }
  }, [_vm._v("I glance over at Selena as she starts to lead the volunteers out into the hall again. “Selena will finish up the tour by taking you up to the common areas the kids share on the second and third floors.” I pause and make sure I’m looking only at the Don Juan of hockey. “We want to work with people who are willing and able, but we understand if it’s not the right fit for you. So take your time, look around, ask any and all questions you have. We want it to be an exceptional experience for both you and the kids. And feel free to ask me anything as well. I’ll be here in the classroom.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p183"
    }
  }, [_vm._v("I give the other three potential volunteers another warm smile as everyone, including Alex, follows Selena upstairs. I go back to cleaning up, but my brain is stuck on Alex. How in the hell is he here? What kind of absurd coincidence is this? I realize now, from the look on his face and the fact that I never gave him my last name when we met, that it has to be a coincidence. He certainly didn’t follow me here from Starbucks and without my last name he couldn’t have Googled me and figured out where I worked. But I have a hard time believing a guy like him would take it upon himself to volunteer here—or anywhere other than maybe a strip club on amateur lap dance night.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p184"
    }
  }, [_vm._v("I have to admit I loved the look on his face when I spoke to him in French in Starbucks and I was tempted to stick around and really enjoy the blush on his cheeks but I didn’t want to risk being late for a meeting with a perspective donor my mom had set up for me. Still, the encounter wasn’t easy to forget and as I headed back here a couple hours later I found myself reliving it and then punching his name into Google on my phone. BIG mistake.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p185"
    }
  }, [_vm._v("Judging by the stories, he’s a world-class flirt. Tons of women—sometimes in nothing more than skimpy bikinis or cocktail dresses—have posted photos with him on social media, and almost always with his lips on their cheek or ear or neck and vice versa. His own social media is filled with half-naked selfies. The guy appears to be about as deep as a puddle.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p186"
    }
  }, [_vm._v("There’s a knock and I put down the easel I’m carrying and turn around. “"), _c('i', [_vm._v("Parler du diable.")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p187"
    }
  }, [_vm._v("He grins at my “speak of the devil” comment. I have to admit it’s a good grin. “"), _c('i', [_vm._v("J’ai été appelé pire")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p188"
    }
  }, [_vm._v("“Yeah, I’m not surprised you’ve been called worse,” I say, frowning. “Why are you here?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p189"
    }
  }, [_vm._v("He steps into the room, the grin falling off his face, and shoves his hands in the pockets of his jeans. “Orientation is over and I wanted to apologize for being late and let you know I really do want to volunteer.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p190"
    }
  }, [_vm._v("I pick up an easel and carry it into the corner where the others are stacked. “Is this a court-ordered thing or something?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p191"
    }
  }, [_vm._v("“Excuse me?” he asks, completely baffled. I turn back to him and he’s moved to the last easel, picking it up much more easily than I do, and carrying it over to the stack where I’m standing.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p192"
    }
  }, [_vm._v("“Were you ordered by the courts to do some kind of community service?” I repeat. I’m honestly not trying to offend him I just can’t for the life of me picture him willingly giving up time to be with kids when he could be hitting on women or taking half-naked selfies for his one million Instagram followers.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p193"
    }
  }, [_vm._v("“Are you serious?” He sighs. “No. I like helping kids. Is that so hard to believe?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p194"
    }
  }, [_vm._v("I shrug. “You don’t come across as someone who cares about much more than hockey and hitting on women.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p195"
    }
  }, [_vm._v("“You have spent five minutes with me.” He looks at me with an annoyed expression.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p196"
    }
  }, [_vm._v("“It could have been seven minutes if you had showed up on time for the volunteer program you say you are so interested in,” I snap back.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p197"
    }
  }, [_vm._v("He rolls his eyes and crosses his arms over his ample chest. “Well here’s a little bit more about me. I prefer sunrises to sunsets. I like cats more than dogs. I will always offer a homeless person food, which is what made me late today, and I also like to donate to fund-raisers that help kids so I was going to offer hockey tickets as one of the prizes for yours.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p198"
    }
  }, [_vm._v("I absorb every word he says with a weird inner satisfaction, like I was hungry for the information and I didn’t know it. While the superficial information is interesting it’s the last two statements that shock me. He was late because he was buying food for a homeless person, which makes me an ass for thinking he was just being inconsiderate of our schedule, and he wants to donate to the fund-raiser. "), _c('i', [_vm._v("My")]), _vm._v(" fund-raiser? “Who told you about the fund-raiser?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p199"
    }
  }, [_vm._v("“Selena. She mentioned it to everyone at the end of the tour.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p200"
    }
  }, [_vm._v("“Why would she do that?” I question, annoyed.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p201"
    }
  }, [_vm._v("“Why wouldn’t she? Is it a secret?” That big, bold obnoxious grin takes over his smug face again. “Just a little advice. Secret fund-raisers don’t raise as much money as the ones you tell people about.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p202"
    }
  }, [_vm._v("“You’re hilarious,” I remark dryly and uncross my arms because they’re starting to ache I’ve had them crossed so tightly for so long. He must take that as a sign of concession, like I’ve waved a white flag.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p203"
    }
  }, [_vm._v("“I told Selena I would come by for my first volunteer shift on Friday. Meet all the kids and figure out what their fitness goals are,” he tells me and then he hesitates before he asks, “Okay?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p204"
    }
  }, [_vm._v("I’ve asked professional athletes to come and just give a talk but no one has taken me up on it. Now this guy is here offering to help and even give me tickets, which would be a big draw for the fund-raiser. I may not trust him as far as I can throw him—and trust me with all that towering height and sculpted muscle I can’t throw him—but I can’t say no. “Okay but, again, I need my volunteers to take this seriously.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p205"
    }
  }, [_vm._v("“I do and I will.” He gives me one more of those confident grins. “You’ll see.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p206"
    }
  }, [_vm._v("Len pops into view behind him. “Sorry to interrupt. I’m going for an afternoon coffee run. Can I get you—”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p207"
    }
  }, [_vm._v("Alex has turned around and that has made Len stop talking for some reason. Her big blue eyes bug out of her head. “You’re Alex Larue.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p208"
    }
  }, [_vm._v("“The one and only.” He smirks as he extends his hand. “And what is your name, beautiful?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p209"
    }
  }, [_vm._v("Len’s eyes fly to my face as she extends her hand. “Did you know this is Alex Larue?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p210"
    }
  }, [_vm._v("“Yes.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p211"
    }
  }, [_vm._v("“I’m Len Levitt. I volunteer here teaching kids budget and money basics,” she explains. “Are you volunteering here?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p212"
    }
  }, [_vm._v("“Yes,” he answers and I can’t see his expression but Len’s cheeks actually start to pink. “Although I had a hard time selling Ms. Bennett here on the idea.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p213"
    }
  }, [_vm._v("Len’s eyes shift to me again. “She doesn’t watch sports. She has no idea you’re a fan favorite for every team you’ve ever played for. The kids will be so psyched to meet you. Oh my God! You should come to her fund-raiser! Brie, invite him to the fund-raiser!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p214"
    }
  }, [_vm._v("She’s fangirling. Full-on. Alex glances over at me and winks. “Are you going to invite me to the fund-raiser?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p215"
    }
  }, [_vm._v("I sigh loudly. “Anyone who donates a prize gets an automatic invite. So yes, you’re invited. But it’s in the Hamptons and you’re probably busy.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p216"
    }
  }, [_vm._v("“As long as I’m not on a road trip I’ll be there,” he promises. “With bells on.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p217"
    }
  }, [_vm._v("“It’s formal, so you should probably wear more than bells,” I snark but it just deepens that grin on his face. “You might even have to buy a suit.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p218"
    }
  }, [_vm._v("“I’m a hockey player,” he reminds me. “We wear suits to every game. You know, I can get you some tickets if you ever want to check out a game yourself.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p219"
    }
  }, [_vm._v("“Like Len said, I don’t watch sports.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p220"
    }
  }, [_vm._v("Len shoots me a weird look and then steps closer to Alex. “It’s nothing personal. She barely watches anything. I’m surprised she even owns a TV. Or a house for that matter since she practically lives here. This place is her baby,” she rambles on. “In fact it’s more her baby than an actual baby would be. If she had kids they’d have to get a room here to see her, she’s here that much. Not that she would be a bad parent. She’s great. She’d be a great parent if she had a kid but she doesn’t have any and doesn’t want any—ever—so you know…anyway she’s got these kids and that’s why this place is her baby.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p221"
    }
  }, [_vm._v("“You should grab that coffee now, Len,” I blurt out before she can dig a deeper hole. Dear God, is this how most woman act around him? “And you should make it a decaf.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p222"
    }
  }, [_vm._v("“Right. Okay. Yes. Nice meeting you, Alex Larue.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p223"
    }
  }, [_vm._v("He chuckles. “You can just call me Alex. And why don’t I walk you out since I’m leaving anyway?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p224"
    }
  }, [_vm._v("“Actually, Len, I need you for a moment so stick around,” I interrupt because the absolute last thing I want in the universe right now is for Len and Alex to spend more time together while she’s become this unhinged crazy lady.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p225"
    }
  }, [_vm._v("Len nods. “See you Friday. And good luck on your road trip tomorrow.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p226"
    }
  }, [_vm._v("“Thank you.” He glances back at me and nods, with the slightest trace of a smile dusting his lips. It’s a smile that says "), _c('i', [_vm._v("See, this is how a proper woman reacts to me.")]), _vm._v(" I return it with an eye roll.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p227"
    }
  }, [_vm._v("I wait until I hear the front door close and see the top of his head pass by the window and then I unleash on Len. “Are you insane? Why are you insane? Why did you just verbally upchuck all over him? About me!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p228"
    }
  }, [_vm._v("Len shrugs sheepishly. “I don’t know you were just being so cold to him. And he’s a freaking celebrity, Brie. He’s the type of person you’ve been trying to get to volunteer here! He’s a guy who can bring us more attention and you were acting like he smelled like dog poop!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p229"
    }
  }, [_vm._v("She probably has a point but I’m still a little mortified. “‘The place is her baby. She would be a good mom but she doesn’t want babies—ever.’ What the hell was that?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p230"
    }
  }, [_vm._v("Len turns bright red and laughs nervously. “I’m sorry. I guess that was TMI, but he’s just…Did you look at him? He’s stunning. All rugged edges and rock-hard body. I mean come on…”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p231"
    }
  }, [_vm._v("I can’t help but smile at her despite her insanity. “Is he good-looking? I can’t see his features. His ego is blocking my view.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p232"
    }
  }, [_vm._v("“Oh come on, he’s a millionaire athlete who has won a damn Stanley Cup. Your ego would be massive too. It’s part of his charm and that French accent is…” She fans herself. Actually fans herself.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p233"
    }
  }, [_vm._v("“I don’t need him for a French accent,” I say in my heaviest French Canadian speak dropping Hs and rolling Rs. Len laughs. Then I tell her about the encounter with him and his teammate earlier at Starbucks. “Isn’t the way he seems to think he’s hot shit and that he can say whatever he wants annoying?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p234"
    }
  }, [_vm._v("“Nope. Not a bit. Because clearly he’s a good guy if he’s here, right?” Len replies. “You should ask him if we can use his name and his prize in the advertising. So many more people will buy tickets if we can say he’ll be there.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p235"
    }
  }, [_vm._v("“You think?” I sound as skeptical as I feel.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p236"
    }
  }, [_vm._v("She nods so emphatically that her ringlets are flying every which way. “Ask Vic, he’ll tell you. Every hockey fan with money will be there. Alex is a darling of the league. He’s a media favorite even though he’s not a grade-A player. They love his witty banter in interviews and apparently he’s a locker room leader.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p237"
    }
  }, [_vm._v("“What the hell is that and how do you know any of this?” I ask and stare at her like she’s not my best friend. Because my best friend has never brought up hockey before in any conversation we’ve ever had.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p238"
    }
  }, [_vm._v("Len is looking back at me like I’m the insane one. “You’re the only child, not me. My brothers have both been hockey fanatics since they were kids. My grandpa got them into it. And remember my college obsession?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p239"
    }
  }, [_vm._v("“Stuart?” I question. Len fell instantly and madly in love with a guy named Stuart who she went on and on about for all four years but never actually dated him or even said more than two words to him that I know of. “He was a massive hockey fan. Huge. Loved it. I started following it a little bit in school so I could have something to talk to him about. Not that I ever did, but it was there in my back pocket if I needed it.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p240"
    }
  }, [_vm._v("“You are a strange bird.” I shake my head.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p241"
    }
  }, [_vm._v("She grins. “Yep. And you’re an even stranger bird for not thinking that boy is hot.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p242"
    }
  }, [_vm._v("I picture Alex Larue in my head. I have to admit when I first turned around to look at him in that coffee line, I was surprised. Tall, broad, sculpted, with that unkempt brown hair and those nicks and scars on his face. He looked like a model who decided to become a MMA fighter—and lost a few rounds. If he hadn’t been vulgarly giving a review of my ass, I might have found all those features attractive. But thanks to the demeaning way he was talking about me, I didn’t have that reaction. What I did react to, because I couldn’t control it, were those stormy blue eyes. When I looked into them, I had trouble looking away. Something about him commands my attention, even if I don’t think much of him, I’m oddly transfixed by him.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p243"
    }
  }, [_vm._v("“Brie? Hello!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p244"
    }
  }, [_vm._v("“What? Sorry. What?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p245"
    }
  }, [_vm._v("“Where did you go?” Len questions. “I asked if you wanted coffee. I’m still going.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p246"
    }
  }, [_vm._v("“Umm…yeah. Thanks. Today let’s go for a half pump hazelnut iced latte with coconut milk.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p247"
    }
  }, [_vm._v("“Got it.” Len leaves and I walk out of the art room and head to my office.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p248"
    }
  }, [_vm._v("Isaac, one of the sixteen-year-olds who has been living at Daphne’s House for almost year, walks in the back door. I smile at him. “Welcome home. Have a good day at school?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p249"
    }
  }, [_vm._v("“It was school,” he says with a shrug but gives me a small smile. “I’m going to try and get my homework done before the budget class so I can play video games tonight.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p250"
    }
  }, [_vm._v("I laugh. “Okay you do that.”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p251"
    }
  }, [_vm._v("He heads straight for the stairs up to the living area. I pause and turn back to him. “Isaac! Have you ever heard of Alex Larue?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p252"
    }
  }, [_vm._v("He stops walking and scrunches up his nose as he thinks about it. “The hockey player?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p253"
    }
  }, [_vm._v("I nod. He smiles. “Yeah. That guy is cool. I saw an interview he did online with ESPN and he was funny. Why?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p254"
    }
  }, [_vm._v("“He’s going to be volunteering here starting Friday,” I explain.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p255"
    }
  }, [_vm._v("Isaac’s smile gets bigger. “Sweet!”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "p256"
    }
  }, [_vm._v("He heads up the stairs, taking them two at a time. Okay…so I’m the only one who doesn’t like this guy.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09305d38","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/s007-Chapter-002.vue
// module id = 81
// module chunks = 0